export const Constants = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCEESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT: 'LOGOUT',
};


export const authUrl = 'https://api.monitoring.gameopedia.com/auth'



// WEBPACK FOOTER //
// ./src/authentication/javascripts/constants.js